import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
  name: 'arquivofilter'
})
export class ArquivoFilterPipe implements PipeTransform {

  transform(items: any[], searchText: string): any[] {
    if(!items) return [];
    if(!searchText) return items;
    searchText = searchText.toLowerCase();
    console.log("SEARCH: "+searchText);
    return items.filter( it => {
      console.log("FILTER: "+it.nmArquivo.toLowerCase());
      return it.nmArquivo.toLowerCase().includes(searchText) | it.dsOrigemArquivo.toLowerCase().includes(searchText);
    });
  }
}



// WEBPACK FOOTER //
// ./src/pipes/filterArquivo.ts